import { css } from '@emotion/react'
import { memo } from 'react'
import i18n from '../../../../utilities/i18n'
import { getThemeSpacing } from '../../../styles/appTheme'

const captionStyles = css({
    display: 'flex',
    flexFlow: 'column nowrap',
    paddingTop: getThemeSpacing(2),
})

const captionCellStyles = css({
    paddingLeft: getThemeSpacing(1),
})

const captionCellLeftStyles = css({
    fontWeight: 'bold' as const,
    paddingRight: getThemeSpacing(1),
})

const mediaStyles = css({
    border: `1px solid rgb(112 112 112 / 35%)`,
    flex: `1 1 100%`,
    height: '100%',
    maxHeight: '40vh',
    maxWidth: '100%',
    objectFit: 'contain',
})

const captionRowStyles = css({
    display: 'flex',
    justifyContent: 'space-evenly',
})

export interface ImageData {
    username: string
    shortcut: string
    src: string
}
interface IBigGif {
    imageData: ImageData
}

const BigGif = memo((props: IBigGif) => {
    const {
        imageData: { username, shortcut, src },
    } = props

    return (
        <>
            <img css={mediaStyles} src={src} alt={shortcut} />
            <div css={captionStyles}>
                {!!username && (
                    <div css={captionRowStyles}>
                        <span css={captionCellLeftStyles}>
                            {i18n.t('chatImages.submittedBy') + ':'}
                        </span>
                        <span css={captionCellStyles}>{username}</span>
                    </div>
                )}
                {!!shortcut && (
                    <div css={captionRowStyles}>
                        <span css={captionCellLeftStyles}>
                            {i18n.t('chatImages.shortcut') + ':'}
                        </span>
                        <span css={captionCellStyles}>{shortcut}</span>
                    </div>
                )}
            </div>
        </>
    )
})

export default BigGif
